// client/questions.js
export const respondentStep = {
  title: "回答者情報",
  description: "診断結果の送付先情報をご入力ください。",
  questions: [
    {
      code: "respondent_name",
      label: "ご担当者名",
      type: "text",
      required: true
    },
    {
      code: "result_delivery_email",
      label: "診断結果送付先メールアドレス",
      type: "email",
      required: true
    },
    {
      code: "contact_information",
      label: "ご連絡先電話番号",
      type: "tel",
      required: true
    }
  ]
};

export const questionSteps = [
  {
    title: "【1】会社について",
    questions: [
      { code: "about_respondents", label: "ご回答者の組織での役割を教えて下さい。　（例：代表、人事管掌役員、人事責任者など）", type: "text" },
      { code: "company_name", label: "会社名（任意）", type: "text" },
      { code: "business_content", label: "主な事業内容を教えてください。（例：医療機器販売、建設業、IT開発、飲食業など）", type: "text" },
      {
        code: "number_employees",
        label: "従業員数はおよそ何名ですか？",
        type: "radio",
        options: ["10名未満", "10名～50名", "51名～100名", "101名～300名", "301名以上"]
      },
      {
        code: "multiple_businesses",
        label: "対象顧客・提供価値（製品）が全く異なる複数の事業を保有し、それぞれに従事している従業員が存在しすか？",
        type: "radio",
        options: ["はい", "いいえ"]
      },
      {
        code: "employee_ratio",
        label: "主な雇用形態の割合を教えて下さい。（正社員比率）",
        type: "radio",
        options: ["約8割以上", "約5割～8割", "約5割未満"]
      },
      {
        code: "business_base",
        label: "事業拠点数を教えて下さい。",
        type: "radio",
        options: ["本社のみ", "複数の国内拠点あり", "海外拠点またはグループ会社あり"]
      }
    ]
  },
  {
    title: "【2】組織と人材の状況",
    questions: [
      {
        code: "human_resources_department",
        label: "社内に人事部（または人事担当部署）は存在しますか？",
        type: "radio",
        options: ["はい（専任部署あり）", "いいえ（他部門と兼任）", "部分的に存在する（総務などに一部機能）"]
      },
      {
        code: "manager_ratio",
        label: "管理職・リーダー層が全社員に占める割合を教えてください。",
        type: "radio",
        options: ["10%未満", "10～30％", "30～50％", "50%超"]
      },
      {
        code: "age_composition",
        label: "社員の年齢構成を教えてください。",
        type: "radio",
        options: ["30代以下が中心", "40代が中心", "50代以上が多い", "幅広い年代が在籍"]
      },
      {
        code: "main_recruitment",
        label: "新規採用対象はどのような層が中心ですか？",
        type: "radio",
        options: ["新卒採用中心", "中途採用中心", "両方同程度", "採用はほとんど行っていない"]
      },
      {
        code: "joining_and_retiring_trends",
        label: "直近3年間の入退社の傾向を教えてください。",
        type: "radio",
        options: ["安定している", "新規採用が増えている", "退職が増えている", "出入りが多い（入退社ともに多い）"]
      }
    ]
  },
  {
    title: "【3】人事制度の整備・運用状況",
    questions: [
      {
        code: "job_ranking_system",
        label: "等級や職位（役職・ランクなど）の仕組みはありますか？",
        type: "radio",
        options: ["明確に定まっている", "一部のみ運用している", "特に決まっていない"]
      },
      {
        code: "evaluation_system",
        label: "社員の評価の仕組みはありますか？",
        type: "radio",
        options: ["評価基準・面談が整備されている", "上司判断で実施している", "特に決まっていない"]
      },
      {
        code: "salary_evaluation",
        label: "給与や賞与はどのように決定していますか？",
        type: "radio",
        options: ["評価・等級に連動して決定している", "役職・勤続などで決まる", "個別判断が多い"]
      },
      {
        code: "training_system",
        label: "社員育成や研修の仕組みはありますか？",
        type: "radio",
        options: ["定期的に行っている", "必要に応じて実施", "特に仕組みはない"]
      },
      {
        code: "reemployment_system",
        label: "再雇用制度がありますか？",
        type: "radio",
        options: ["はい", "いいえ"]
      }
    ]
  },
  {
    title: "【4】現状の課題とアセスメント目的",
    questions: [
      {
        code: "issues",
        label: "現在人事や組織で課題と感じていることを教えてください。　※複数選択可",
        type: "checkbox",
        options: ["採用がうまくいかない", "若手が定着しない", "評価・給与の公平感", "管理職育成", "制度が形だけ", "組織の一体感不足", "その他（自由記入）"]
      },
      { code: "issues_others_comments", label: "組織課題　その他　記入欄", type: "text" },
      {
        code: "purpose",
        label: "今回の診断を受けたい主な目的を教えてください。　※複数選択可",
        type: "checkbox",
        options: ["現状の整理", "制度見直し", "社員の意見把握", "将来成長に向けて整備", "その他（自由記入）"]
      },
      { code: "others_comments", label: "その他　記入欄", type: "text" },
      {
        code: "scope_of_diagnosis",
        label: "今回の診断対象範囲を教えてください。",
        type: "radio",
        options: ["全社", "管理職・本社中心", "特定部門・職種のみ"]
      },
      { code: "concerns_and_issues", label: "人事制度や組織に関して特に気になっている点", type: "text" }
    ]
  },
  // -------------------------
  // WHY / WHAT / DO / FEEL / IMPROVE
  // -------------------------
  {
    title: "Ⅰ：戦略との整合性（WHY）",
    questions: [
      {
        code: "why_questions_1",
        label: "経営方針や事業戦略が人事制度（評価・報酬・等級）に反映されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "why_questions_2",
        label: "「どのような人材を増やしたい／評価したいか」が明確になっている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "why_questions_3",
        label: "新規事業や変化対応に合わせて制度を見直している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "why_questions_4",
        label: "報酬・人件費の方針が経営計画に基づいて設定されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "why_questions_5",
        label: "経営層が制度の目的・方針を社員に発信している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      }
    ]
  },
  {
    title: "Ⅱ：制度設計の妥当性（WHAT）",
    questions: [
      {
        code: "what_questions_1",
        label: "等級制度の考え方（役割・能力・成果など）が明確である。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "what_questions_2",
        label: "評価制度の目的（能力向上・成果評価など）が整理されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "what_questions_3",
        label: "評価基準が職種・職位に応じて適切に設定されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "what_questions_4",
        label: "評価結果が給与・賞与・昇格に明確に反映されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "what_questions_5",
        label: "育成・教育の仕組みが評価制度と連動している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      }
    ]
  },
  {
    title: "Ⅲ：運用・マネジメント実行力（DO）",
    questions: [
      {
        code: "do_questions_1",
        label: "評価者（上司）による面談・フィードバックが定期的に行われている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "do_questions_2",
        label: "評価結果や昇格基準が社員に分かりやすく伝えられている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "do_questions_3",
        label: "評価のばらつきや不公平を防ぐ仕組みがある。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "do_questions_4",
        label: "人事データ（評価履歴・給与情報など）が整備されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "do_questions_5",
        label: "マネジャー層が人材育成・評価に主体的に関与している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      }
    ]
  },
  {
    title: "Ⅳ：納得感・エンゲージメント（FEEL）",
    questions: [
      {
        code: "feel_questions_1",
        label: "評価や報酬の仕組みが社員に理解されている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "feel_questions_2",
        label: "評価や昇格に対して公正さが保たれている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "feel_questions_3",
        label: "成果を出した社員が正当に報われていると感じる。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "feel_questions_4",
        label: "社員が自分の成長・キャリアの方向性を描けている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "feel_questions_5",
        label: "人事制度が会社への信頼や働きがいに繋がっている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      }
    ]
  },
  {
    title: "Ⅴ：改善・進化の姿勢（IMPROVE）",
    questions: [
      {
        code: "improve_questions_1",
        label: "制度改善に関する意見や要望を吸い上げる仕組みがある。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "improve_questions_2",
        label: "経営や人事が制度を定期的に見直している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "improve_questions_3",
        label: "制度改定時に社員の意見を反映している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "improve_questions_4",
        label: "外部環境（業界・人材市場）を踏まえた制度見直しをしている。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      },
      {
        code: "improve_questions_5",
        label: "制度の目的や運用方針を定期的に社員に説明している。",
        type: "radio",
        options: ["①全くあてはまらない", "②あてはまらない", "③どちらともいえない", "④あてはまる", "⑤とてもあてはまる"]
      }
    ]
  }
];
